import React from 'react';
import { StyleServicesPage } from './FAQ.styled';
import { useTranslation } from '../../../hooks/useTranslation';

/**
 * Renders the Frequently Asked Questions (FAQ) section with collapsible accordion panels.
 * @todo Style Component
 * @component
 * @param {Object} props - The component props.
 * @param {Array<Object>} props.data - An array of objects containing FAQ data.
 * @returns {JSX.Element} - The rendered FAQ section.
 */

const FAQ = (props) => {
  const t = useTranslation();
  return (
    <>
      <StyleServicesPage id='FAQs' data-testid='FAQ-test'>
        <div className='title'>{t('app.FAQ')}</div>
        <div className='accordion' id='accordionExample'>
          {props.data.map((faqItem, index) => (
            <div className='accordion-item' key={index}>
              <h3 className='accordion-header'>
                <button
                  className={`accordion-button ${
                    index === 0 ? '' : 'collapsed'
                  }`}
                  type='button'
                  data-bs-toggle='collapse'
                  data-bs-target={`#collapse${index}`}
                  aria-expanded={index === 0 ? 'true' : 'false'}
                  aria-controls={`collapse${index}`}
                >
                  {faqItem.question}
                </button>
              </h3>
              <div
                id={`collapse${index}`}
                className={`accordion-collapse collapse ${
                  index === 0 ? 'show' : ''
                }`}
                data-bs-parent='#accordionExample'
              >
                <div className='accordion-body'>
                  {faqItem.answer}
                  {faqItem.answerPoints
                    ? faqItem.answerPoints.map((list, index) => (
                        <li key={index}>{list}</li>
                      ))
                    : ''}
                </div>
              </div>
            </div>
          ))}
        </div>
      </StyleServicesPage>
    </>
  );
};

export default FAQ;
